import React from "react";
import queryString from "query-string";
import { Button, Form, Progress, Alert } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import { checkDeviceIOS } from '../../utils'

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = "ent";
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: "",
      },
      username: "",
      password: "",
    };
  }

  componentDidMount() {
    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message,
      },
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: "",
      },
    });



    this.props.api
      .userPassLogin(
        {
          username: this.usernameInput.value,
          password: this.passwordInput.value,
        },
        this.parameters
      )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location =
          this.parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const translate = this.props.translate(error.errorCode);

        let message = "Usuário e senha inválidos.";

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }
        this.setState({
          onLogin: false,
          error: { open: true, message: message },
        });
      });
  }

  render() {
    const { translate } = this.props;

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div ref={this.ref}>
          <Form onSubmit={(event) => this.onSubmit(event)}>
            <p className="ep-label">E-mail</p>
            <input
              className="ep-input"
              disabled={this.state.onLogin}
              ref={(ref) => {
                this.usernameInput = ref;
              }}
              required={true}
              tabIndex={1}
              type="text"
              autoCorrect="off"
              autoCapitalize="none"
              id="username"
            />
            <p className="ep-label">Senha</p>
            <input
              className="ep-input"
              required={true}
              disabled={this.state.onLogin}
              ref={(ref) => {
                this.passwordInput = ref;
              }}
              tabIndex={1}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              id="password"
            />
            <div>
              {!this.state.onLogin ? (
                <Button
                  block={!this.parameters.failureRedirect}
                  size="lg"
                  tabIndex={1}
                  type="submit"
                  id="submmit"
                  className="ep-btn"
                  disabled={!this.props.turnstileSuccess}
                >
                  {translate("ButtonEnter")}
                </Button>
              ) : (
                <Progress animated color="danger" value={100} />
              )}
            </div>
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={this.state.error.open}
                toggle={() => this.setState({ error: { open: false } })}
              >
                {this.state.error.message}
              </Alert>
            </div>
            <div className="ep-footer">
              <a href="https://www.enterplay.com.br/Account/RecoverPassword" classNmae="ep-a">Esqueci minha senha</a>
              <br />
              {
                checkDeviceIOS() ? '' : <span>Ainda não é cadastrado? <a href="https://www.enterplay.com.br/Account/Register" classNmae="ep-a">Cadastre-se</a></span>
              }
            </div>
          </Form>
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { style: { marginTop: '2rem' } });
